module.exports = __webpack_public_path__ + "img/inspection.c387261f.svg";